export const HOTKEYS = {
  SPACE: "space",
  LEFT: "left",
  RIGHT: "right",
  CMD: "meta",
};
